import React, { FC } from 'react';
import { Button } from '../Button/Button';
import { ReactComponent as MoreIcon } from '../../images/icons/more-vertical.svg';
import { ReactComponent as EditIcon } from '../../images/icons/edit-3.svg';
import { ReactComponent as DeleteIcon } from '../../images/icons/x-circle.svg';
import { showConfirm } from '../ConfirmModal/showConfirm';
import { Flyout } from '../Flyout/Flyout';
import useToggleState from '../../utils/react/useToggleState';
import { Link } from 'react-router-dom';
import { College } from 'shared/lib/types/College';
import { useCollegeList } from '../../contexts/CollegeListContext';

export interface CollegeListItemProps {
  college: College;
  className?: string;
}

export const CollegeListItem: FC<CollegeListItemProps> = ({
  college,
  className = '',
  ...rest
}) => {
  const { deleteCollege } = useCollegeList();
  const [showMenu, toggleMenu] = useToggleState();

  return (
    <li
      {...rest}
      className={`row items-center justify-between py-3 ${className}`}
    >
      <div className="text-sm font-semibold text-gray-800 flex-grow">
        {college.name}
      </div>
      <div className="relative flex-shrink-0">
        <Button
          backgroundColor="none"
          textColor="uo-green"
          size="small"
          onClick={toggleMenu}
        >
          <MoreIcon />
        </Button>
        {showMenu && (
          <Flyout
            arrowSide="top-right"
            color="uo-green"
            borderRadius="xl"
            className="w-52 top-0 right-0 mt-12 -mr-2"
            onClickOutside={toggleMenu}
          >
            <Link to={`/admin/college/${college.id}/edit`}>
              <Button
                backgroundColor="none"
                textColor="white"
                size="small"
                className="row items-center px-0 mb-3"
                onClick={toggleMenu}
              >
                <EditIcon className="mr-3" /> Edit College
              </Button>
            </Link>
            <Button
              backgroundColor="none"
              textColor="white"
              size="small"
              className="row items-center px-0"
              onClick={async () => {
                toggleMenu();
                if (
                  await showConfirm({
                    title: 'Delete College',
                    message: `You are about to delete college “${college.name}.” Are you sure you wish to delete this college?`,
                    confirmButtonText: 'Delete',
                  })
                ) {
                  await deleteCollege({ collegeId: college.id });
                }
              }}
            >
              <DeleteIcon className="mr-3" /> Delete College
            </Button>
          </Flyout>
        )}
      </div>
    </li>
  );
};
